import { combineReducers } from 'redux';

import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import { CREATE_INTERVENTION_REMINDER_REQUEST } from 'modules/interventions/actionTypes';

export default combineReducers({
  isLoading: loading(CREATE_INTERVENTION_REMINDER_REQUEST),
  apiError: error(CREATE_INTERVENTION_REMINDER_REQUEST),
});
